/**
 * Create a simple get/set handler pair for a `path()`,
 * allowing for retrieval and mutation of a single value
 * @param {*} [initialValue] - an optional initial value for the path
 * @returns {Object} - a route definition containing the get and set handlers
 * @example
 * muster()
 *   .path('app.currentSelectionId', variable());
 *   .path('app.selectionCount', variable(0));
 */
function variable(initialValue) {
  let currentValue = initialValue;
  return {
    get: (args) => {
      if (Array.isArray(args)) {
        throw new Error('variable() cannot be used with match(), please use path() instead');
      }
      const { res } = args;
      return res.value(currentValue);
    },
    set: ({ req, res }) => {
      currentValue = req.value;
      return res.ok();
    },
  };
}

module.exports = variable;
